import { flow, pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/lib/TaskEither';
import {
  addVersionForUpdate,
  createAuthorizedDeleteRequest,
  createAuthorizedGetRequest,
  createAuthorizedPostRequest,
  createAuthorizedPutRequest,
  decode,
  decodeVersioned,
  encodePaginatableQuery,
  fetchApi,
  PaginatableQuery,
  setBody,
  setQuery,
  Versioned,
} from '../..';
import { formCodec, listCodec, recordCodec } from '@/services/api/resources/report-template/codec';
import { ReportTemplate } from '@/services/api/resources/report-template/model';

const baseUrl = '/v2/report-templates';
const recordUrl = (id: number) => `${baseUrl}/${id}`;

export const list = (query: PaginatableQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodePaginatableQuery(query))),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const remove = flow(
  recordUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const create = (editedReportTemplate: Record<string, unknown>) => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  map(setBody({ ...editedReportTemplate })),
  chain(fetchApi),
);

export const get = flow(
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decodeVersioned(recordCodec)),
);

export const update = (id: number, editedReportTemplate: Versioned<ReportTemplate>) => pipe(
  id,
  recordUrl,
  createAuthorizedPutRequest,
  map(addVersionForUpdate(editedReportTemplate.version)),
  map(setBody(formCodec.encode(editedReportTemplate.data))),
  chain(fetchApi),
);
